import { z } from 'zod/v4';

export const TimeIntervalDTO = z.object({
  id: z.string(),
  name: z.string(),
  config: z.string(),
});

export const TimeIntervalItemDTO = TimeIntervalDTO.pick({
  id: true,
  name: true,
});

export type TimeInterval = z.infer<typeof TimeIntervalDTO>;
export type TimeIntervalItem = z.infer<typeof TimeIntervalItemDTO>;